import { openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_popover = _resolveComponent("el-popover");
  return _openBlock(), _createBlock(_component_el_popover, {
    placement: _ctx.placement,
    title: _ctx.title,
    "popper-style": 'width: fit-content;',
    trigger: "hover",
    "hide-after": _ctx.hideAfter,
    "popper-class": _ctx.popperClass,
    disabled: _ctx.disabled,
    "show-arrow": _ctx.showArrow
  }, {
    default: _withCtx(() => [_ctx.label ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "htmlToolTipLabel",
      innerHTML: _ctx.sanitizedLabel
    }, null, 8, _hoisted_1)) : _renderSlot(_ctx.$slots, "content", {
      key: 1
    }, undefined, true)]),
    reference: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
    _: 3
  }, 8, ["placement", "title", "hide-after", "popper-class", "disabled", "show-arrow"]);
}